module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAARCAMAAAAi2lQfAAAAOVBMVEUAAADT6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P3T6P2JChxVAAAAEnRSTlMA3ege2ctOKhgRCtS++cOxJA4X10cgAAAAX0lEQVRIx92WOQ6AMAwEndiEK1z7/8dSUEBLmpEyLxhZ9q6NoRyLkZRNFTUYs7RfhvAaDLOBnIk28CStk4F4PAYJI0sKN7FUfgIYHlL82sK+rqAlB3pKQrwL8Db8/AM3mK0NoIaXWRcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/specailPage/div2_tipline.png
// module id = yLCM
// module chunks = 1